import React from 'react';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import IconTune from '@mui/icons-material/TuneRounded';
import DateRangeHeader from '../../../components/dateRangeHeader/DateRangeHeader';
import styles from './TransactionsFilters.module.css';

/** Período (atalhos e datas) + tipo e categoria, num card só. */
function TransactionsFilters({ filters, categories, onPeriodChange, onFilterChange }) {
    return (
        <section className={styles.card}>
            <div className={styles.head}>
                <span className={styles.headIcon}><IconTune fontSize="small" /></span>
                <h3 className={styles.title}>Filtros</h3>
            </div>

            <div className={styles.period}>
                <DateRangeHeader
                    initialStartDate={filters.startDate}
                    initialEndDate={filters.endDate}
                    onChange={onPeriodChange}
                />
            </div>

            <div className={styles.selects}>
                <FormControl size="small" className={styles.select}>
                    <InputLabel>Tipo</InputLabel>
                    <Select
                        name="type"
                        value={filters.type}
                        onChange={onFilterChange}
                        label="Tipo"
                    >
                        <MenuItem value="all">Todos</MenuItem>
                        <MenuItem value="income">Receitas</MenuItem>
                        <MenuItem value="expense">Despesas</MenuItem>
                    </Select>
                </FormControl>
                <FormControl size="small" className={styles.select}>
                    <InputLabel>Categoria</InputLabel>
                    <Select
                        name="categoryId"
                        value={filters.categoryId}
                        onChange={onFilterChange}
                        label="Categoria"
                    >
                        <MenuItem value="all">Todas</MenuItem>
                        {categories.map(category => (
                            <MenuItem key={category.id} value={category.id}>
                                {category.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
        </section>
    );
}

export default TransactionsFilters;
